<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>This book is dedicated to the memory of Tommy.</i></p>
<p class="ded1"><i>Goodbyes are not forever.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?8918a844